import HeroSection from "../../components/client-side/aboutus/HeroSection";
// import PartnersLogo from "../../components/client-side/aboutus/PartnersLogo";
// import TeamAuthors from "../../components/client-side/aboutus/TeamAuthors";
import ContactSection from "../../components/client-side/homepage/ContactSection";
import WelcomeSection from "../../components/client-side/aboutus/welcomeSection";
const AboutUsPage = () => {
  return (
    <div className="min-h-screen bg-background dark:bg-darkbg text-black dark:text-textDark transition-colors duration-300">
      <main>
        <HeroSection />
        {/* <PartnersLogo /> */}
        {/* <TeamAuthors /> */}
        <WelcomeSection />
        <ContactSection />
      </main>
    </div>
  );
};

export default AboutUsPage;
